<div class="px-8 py-6">
  <div class="body-wrapper">
    <ng-content></ng-content>
  </div>
</div>
